import {Component, ElementRef, ViewChild} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {Database} from "sql.js";
import {Parser} from "xml2js"
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {HttpClient} from "@angular/common/http";
import {GlobalProvider} from "../../providers/global/global";
import {ImportProvider} from "../../providers/import/import";

/**
 * Generated class for the SettingDatabaseImportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-database-import',
  templateUrl: 'setting-database-import.html',
})
export class SettingDatabaseImportPage {

  @ViewChild('file') fileRef: ElementRef
  public acceptImageTypes: Array<string> = ['.cqs', '.sec'];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private alertCtrl: AlertController,
              private dataProvider: DataProvider,
              private http:HttpClient,
              private globalProvider: GlobalProvider,
              private importProvider: ImportProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingDatabaseImportPage');
  }

  public onFilePicked(fileInput: any): void {
    let file:File = fileInput.target.files[0];
    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    if(this.acceptImageTypes.indexOf(fileExtension) !== -1){

      // info: script to send the import file to the node server to process the import
      let formData = new FormData();
      formData.append('userMail', this.globalProvider.user.email);
      formData.append('importFile', file, file.name);
      this.http.post(this.globalProvider.apiURL+'/api/v2/import', formData)
        .subscribe((success) => {

          this.fileRef.nativeElement.value = '';

          console.log('successfully upload file');
        }, (error) => {
          console.log('error while uploading file');
          console.dir(error);
          this.fileRef.nativeElement.value = '';
        })
    }
    else {
      //dataType not accept
      let alert = this.alertCtrl.create({
        title: 'Dateityp wird nicht Unterstützt',
        subTitle: 'Die von Ihnen ausgewählte Datei wird nicht Unterstützt. Bitte wählen Sie eine Datei folgenden Types aus: ' + this.acceptImageTypes.join(', '),
        buttons: ['OK']
      });
      alert.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/setting-database-import/setting-database-import.ts